import { Texture, Vector4 } from "three";

function createZygosityTexture({ size, strokeWidth }) {
  const side = size * 2;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = side;
  canvas.height = side;

  const textureCoordsMap = [
    new Vector4(0, 0, 0.25, 0.25), // somatic
    new Vector4(0.25, 0.5, 0.25, 0.25), // half right (hetero 2)
    new Vector4(0.25, 0.5, 0.25, 0.25), // half right (hetero 2)
    new Vector4(0.25, 0.25, 0.25, 0.25), // full (homo)
    new Vector4(0.75, 0.75, 0.25, 0.25), // empty
    new Vector4(0, 0.25, 0.25, 0.25), // half right het phased
    new Vector4(0.25, 0, 0.25, 0.25), // half left het phased
  ];

  const s = side / 4;
  const h = size / 4;

  for (let xi = 0; xi < 3; xi++) {
    for (let yi = 0; yi < 3; yi++) {
      const x = h + xi * s;
      const y = h + yi * s;
      const first = xi === 0 && yi === 0;
      const mult = first ? 2 : 1.5;
      const isOut = xi > 1 || yi > 1;
      const color = "#000000FF";
      const pi = Math.PI;
      const a1 = isOut ? pi * 0.75 : pi * 0.5; // start angle of half arc left
      const a2 = isOut ? pi * 1.75 : pi * 1.5; // start angle of half arc right

      ctx.lineWidth = strokeWidth * mult;
      ctx.strokeWidth = 0;

      ctx.fillStyle = xi % 2 ? color : "#00000000";
      ctx.beginPath();
      ctx.arc(x, y, h - strokeWidth, a1, a1 + pi);
      ctx.fill();
      ctx.stroke();

      ctx.strokeWidth = 0;
      ctx.fillStyle = yi % 2 ? color : "#00000000";

      ctx.beginPath();
      ctx.arc(x, y, h - strokeWidth, a2, a2 + pi);
      ctx.fill();

      ctx.strokeStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, h - strokeWidth, 0, pi * 2);
      ctx.stroke();

      if (first) {
        ctx.beginPath();
        ctx.arc(x, y, h - 4 * strokeWidth, 0, 2 * pi);
        ctx.fillStyle = color;
        ctx.fill();
      }
    }
  }

  const texture = new Texture(canvas);
  texture.flipY = false;
  texture.needsUpdate = true;

  canvas.remove();

  return { texture, textureCoordsMap };
}

export default createZygosityTexture;
